"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.danger = exports.valid = exports.focus = exports.disabled = exports.enabled = void 0;
var _core = require("@emotion/core");
var _border = require("../border");
const enabled = _ref => {
  let {
    theme
  } = _ref;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColorneutral05};
`;
};
exports.enabled = enabled;
const disabled = _ref2 => {
  let {
    theme
  } = _ref2;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColorneutral04};
`;
};
exports.disabled = disabled;
const focus = _ref3 => {
  let {
    theme
  } = _ref3;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColorsecondary05};
`;
};
exports.focus = focus;
const valid = _ref4 => {
  let {
    theme
  } = _ref4;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColorsuccess};
`;
};
exports.valid = valid;
const danger = _ref5 => {
  let {
    theme
  } = _ref5;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColordanger};
`;
};
exports.danger = danger;
const warning = _ref6 => {
  let {
    theme
  } = _ref6;
  return (0, _core.css)`
  ${(0, _border.thin)({
    theme
  })};
  border-color: ${theme.bColorwarning};
`;
};
exports.warning = warning;